import { render, staticRenderFns } from "./notifications_dropdown_item.vue?vue&type=template&id=fa7d978e"
import script from "./notifications_dropdown_item.vue?vue&type=script&lang=js"
export * from "./notifications_dropdown_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports